import React, { useContext } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import { WishlistContext } from "../context/WishlistContext";
import { HeartFill, Trash } from "react-bootstrap-icons";
import { image_base_url } from "../admin/api/api";
import "./Wishlist.scss";

const Wishlist = () => {

  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);

  const userData = localStorage.getItem("user");
  const user = userData ? JSON.parse(userData) : null;
 
  const { wishlistItems, removeFromWishlist } = useContext(WishlistContext);


//   const moveToCart = (product) => {
//   addToCart(product);
//   removeFromWishlist(product.id);
// };

const moveToCart = (product) => {

  const cartProduct = {
    id: product.id,
    name: product.name,
    price: product.price,
    mrp: product.mrp,

    // fix image
    image: product.image 
      ? product.image 
      : (product.images && product.images.length > 0 
          ? product.images[0] 
          : ""),

    quantity: 1,

    size: product.size || "",
    color: product.color || "",
    variantId: product.variantId || null
  };

  addToCart(cartProduct);

  removeFromWishlist(product.id);
};


  return (
    <Container className="wishlist-page mt-5 pt-3">
      <h3 className="fw-bold mb-4">My Wishlist</h3>

      {wishlistItems.length === 0 ? (
        <div className="empty-wishlist text-center">
          <HeartFill className="empty-heart" />
          <h4>Your Wishlist is Empty</h4>
          <p className="text-muted">
            Save your favorite products here ❤️
          </p>
          <Button variant="dark" onClick={() => navigate("/")}>
            Continue Shopping
          </Button>
        </div>
      ) : (
        <Row>
          {wishlistItems.map((item) => (
            <Col md={3} sm={6} key={item.id} className="mb-4">
              <Card className="wishlist-card h-100">

                <div className="wishlist-img-wrapper">
                  <Card.Img
                    variant="top"
                    src={`${image_base_url}${item.images?.[0]}`}
                    className="wishlist-img"
                  />

                  <Button
                    variant="light"
                    size="sm"
                    className="remove-btn"
                    onClick={() => removeFromWishlist(item.id)}
                  >
                    <Trash />
                  </Button>
                </div>

                <Card.Body className="wishlist-body d-flex flex-column">

  {/* Product Title */}
  <Card.Title className="wishlist-title">
    {item.name}
  </Card.Title>

  {/* Description */}
  <p className="wishlist-desc">
    {item.description}
  </p>

  {/* Price Section */}
  <div className="wishlist-price">

    <span className="price">₹ {item.price}</span>

    <span className="mrp">
      ₹ {item.mrp}
    </span>

    <span className="discount">
      {item.discount}% OFF
    </span>

  </div>

  {/* Move to Cart Button */}
  <Button
    className="wishlist-cart-btn mt-auto"
    onClick={() => moveToCart(item)}
  >
    Move to Cart
  </Button>

</Card.Body>

              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Wishlist;